var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:{'color-light': _vm.isExpired}},[_vm._v(" "+_vm._s(_vm.epochStatus)+" : "+_vm._s(_vm.epochStart)+" - "+_vm._s(_vm.epochEnd)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }